if (!customElements.get("el-benefits-accordion-slider")) {
  customElements.define(
    "el-benefits-accordion-slider",
    class ElBenefitsAccordionSlider extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === "true") return;
        this.dataset.ready = "true";

        this.cards = Array.from(this.querySelectorAll("[data-benefit-card]"));
        this.triggers = Array.from(
          this.querySelectorAll("[data-benefit-trigger]"),
        );

        this.setupAccordion();
      }

      setupAccordion() {
        this.cards.forEach((card) => {
          const content = card.querySelector("[data-benefit-content]");

          if (!content) return;

          if (card.classList.contains("is-active")) {
            content.style.maxHeight = `${content.scrollHeight}px`;
          }
        });

        this.triggers.forEach((trigger) => {
          trigger.addEventListener("click", (event) => {
            event.preventDefault();

            const card = trigger.closest("[data-benefit-card]");
            if (!card) return;

            const isActive = card.classList.contains("is-active");

            this.closeAll();

            if (!isActive) {
              this.openCard(card);
            }
          });
        });

        window.addEventListener("resize", this.updateActiveHeights);
      }

      disconnectedCallback() {
        window.removeEventListener("resize", this.updateActiveHeights);
      }

      closeAll() {
        this.cards.forEach((card) => {
          const trigger = card.querySelector("[data-benefit-trigger]");
          const content = card.querySelector("[data-benefit-content]");

          card.classList.remove("is-active");

          if (trigger) {
            trigger.setAttribute("aria-expanded", "false");
          }

          if (content) {
            content.style.maxHeight = null;
          }
        });
      }

      openCard(card) {
        const trigger = card.querySelector("[data-benefit-trigger]");
        const content = card.querySelector("[data-benefit-content]");

        card.classList.add("is-active");

        if (trigger) {
          trigger.setAttribute("aria-expanded", "true");
        }

        if (content) {
          content.style.maxHeight = `${content.scrollHeight}px`;
        }
      }

      updateActiveHeights = () => {
        this.cards.forEach((card) => {
          if (!card.classList.contains("is-active")) return;

          const content = card.querySelector("[data-benefit-content]");

          if (content) {
            content.style.maxHeight = `${content.scrollHeight}px`;
          }
        });
      };
    },
  );
}
